<script>
import UsersApi from "@/services/users-api";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}

export default {
      components: {},

    props: {
    customerId:{
          type:(Number),
          default:0
      },
},

  data() {
    return {
        usersFilter:null,
        usersList: [],
        customersList:[],
        customersFilter:null,
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        customersListFields: 
            [
                
                { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                { key:"extId", label: "Code",   sortable: false, tdClass:"font-weight-bold ",},
                { key:"country", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"city", label: "",   thClass:"text-left d-md-table-cell d-none", tdClass:"text-left d-md-table-cell d-none"},
                // { key:"phone", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"address", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"users", label: "",thClass:"text-center", tdClass:"text-center"},
                { key:"status", label: "",thClass:"text-center", tdClass:"text-center"},
                

                { key:"actions", label:""}
            ],
        type:null,
        isCustomersTableBusy:false,
        showDetailsModal:false,
        showConditionsModal:false,
        citiesList:[],
        countriesList:[],
        selectedCountry:null,
        selectedCity:null,
        if_form_error:false,
        showForm:false,
        permissionGroupes:[
            { id: 8, label: "Administrateur Officine",isSelected: 0 ,permission:"CUST_ADMIN" ,IsVisible: true},
            { id: 3, label: "Liste des Commandes",isSelected: 0 ,permission:"ORDER_LIST"},
            { id: 0, label: "Liste des Factures" ,isSelected: 0 , permission: "INVOICE" },
            { id: 5, label: "Liste des Bons de Livraisons",isSelected: 0 ,permission:"BON_LIV"},
            { id: 1, label: "Liste des Avoirs" ,isSelected: 0 ,permission: "AVOIR"},
            { id: 6, label: "Ajout des nouvelles Commandes" ,isSelected: 0 ,permission:"ADD_ORDER"},
            { id: 4, label: "Accès aux Reporting",isSelected: 0 ,permission:"REPORTING"},
            { id: 2, label: "Mails de notifications commandes" ,isSelected: 0 , permission:"EMAIL_STATES_ORDER", IsVisible: true },
            { id: 7, label: "Utiliser Login pour les notifs e-mails" ,isSelected: 0 ,permission:"EMAIL_RECEIVE_ON_OWN_MAIL_ADDRESS"}
        ],
     
        selectedUser:{
            id:'',name:'',userName:'',password:'',
            supplierId:null,status:1, 
            extSystemId:'', 
            codeCustomer:null,
            customerName:'',
            permission:[],
        },
        showUsersModal:false,
        showPWModal:false ,
        isNew:false,
        selectedUserList:[],
        isPasswordChange:false,
        newPassword:null,
        selected:{country:"",city:""},    
        passwordHidden:true,
        showTraderModal:false,
        tradersList:[],

    
        selectedTrader:null,
        selectedPDF:null,
        gotTradersList:false,
        companyName:''
      }
      
    },

    
    computed: {
        orderStatePermission() {
          return this.getPermission("EMAIL_STATES_ORDER");
        },
        adminPermission() {
          return this.getPermission("CUST_ADMIN");
        },
        adminPermissionGroupes() {
            return this.permissionGroupes.filter(element =>  !element.IsVisible );
        },
    },

  mounted() {
    this.getUserInfo()
    this.companyName = getCookie('companyName') 
  }, 
    
  methods: {

    setInfoCutommer(info){
        this.selectedUser.codeCustomer=info.codeCustomer
        this.selectedUser.customerName=info.customerName
    },

    setAllSelectedToZero() {
      if (this.permissionGroupes) {
        this.permissionGroupes.forEach(permission => {
            permission.isSelected = 0;
        });
      }
    },
    handler(permissions) {
        this.permissionGroupes.forEach(permission => {
            if (permissions.includes(permission.permission)) {
                permission.isSelected = 1;
            }

            else  {
                permission.isSelected = 0;
            }
        });
      },

    getUserInfo(){
        if (!this.customerId) {
        UsersApi.getUserInfo().then(
            result => {
                this.selectedUserList = result;
                this.setInfoCutommer(result[0])
            }
        );
    } else {
        
        UsersApi.getUserInfo(this.customerId).then(
            result => {
                this.selectedUserList = result;
                this.setInfoCutommer(result[0])
            }
        );
    }
},


    addNew(){
      this.setAllSelectedToZero()
      this.showUsersModal=true 
      this.showForm =true;
      this.cancelUserEdit();
      this.selectedUser.userName= ''
      this.isNew=true
      this.isPasswordChange=false
} ,

    cancelUserEdit(){
      this.isNew=false
      this.selectedUser.id=null
      this.selectedUser.name=''
      this.selectedUser.userName=''
      this.selectedUser.password=''
      this.selectedUser.extSystemId=''
      this.selectedUser.permission=[];
      
    },

    hideForm(){
      this.showForm =false;
      this.showUsersModal=false 
      this.isNew=false
    },

    editUser(user){
        this.showUsersModal=true 
        this.showForm =true;
        this.isPasswordChange=false
        this.cancelUserEdit();
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
        this.selectedUser.status=user.status
        this.selectedUser.extSystemId=user.extSystemId
        this.selectedUser.codeCustomer=user.codeCustomer
        this.selectedUser.isCustomerAdmin=user.isCustomerAdmin
        this.handler(user.permission)

        
    },

    saveUser(){
        this.selectedUser.customerId= this.customerId
        this.selectedUser.permission= this.permissionGroupes
        .filter(permission => permission.isSelected == 1)
        .map(permission => permission.permission);

       UsersApi.saveUser(this.selectedUser).then(
        (result)=> {
            if(result){
                this.cancelUserEdit()
                this.hideForm()
                this.getUserInfo(this.selectedUser.customerId)          
            }

        }
      ) 
    },

    showHidePassword(){
        this.passwordHidden=!this.passwordHidden
    },
    changePassword(user){
        this.showPWModal =true;
        this.isPasswordChange = true
        this.hideForm()
        this.selectedUser.id=user.id
        this.selectedUser.name=user.name
        this.selectedUser.userName=user.userName
    },
    cancelPasswordChangeEdit(){
        this.isPasswordChange= false
        this.cancelUserEdit()
        this.newPassword=null
        this.hideForm()
        this.showPWModal=false
    },

    updatePassword(){
        this.selectedUser.supplierId= this.selected ? this.selected.id : null
        UsersApi.adminUpdatePassword(this.selectedUser.id,this.newPassword).then(
        ()=> {
            this.getUserInfo(this.selectedUser.supplierId)          
            this.cancelPasswordChangeEdit()
        }
      )
    },

    getPermission(permission) {
        const foundElement = this.permissionGroupes.find(element => element.permission === permission);
        return foundElement || null;
    }
},



};
</script>
<style>

    .style-vselect .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }

</style>
<template>

    <div class="row pt-4 ">    
      <div class="col-sm-12">
        <div class="">
          <div class="">
            <div class="row pb-4">
                <div class="col-lg-10 col-md-9 col-sm-12">
                    <h3 class="card-title font-size-22 mb-4" style="font-size:22px;">{{$t('subscription.table.users')}} <strong>{{this.selectedUser.customerName}}</strong> </h3>
                    </div>
                        <div class="col-lg-2 col-md-3 col-sm-12 text-right">
                            <b-button variant="success" @click="addNew()"  class="float-right mb-4">
                                <i class="fas fa-plus text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
                                <span class=" font-weight-bold text-white text-uppercase">{{$t('subscription.userModal.addNew')}} </span>
                            </b-button>
                        </div>      
                </div>

                <div class="table-responsive"  >
            <table class="table table-centered " >
            <thead class="thead-light">
                <tr>
                    <th></th>
                    
                
                <th class="text-left">{{$t('subscription.userModal.table.name')}}</th>
                <th class="text-left">{{$t('subscription.userModal.table.userName')}}</th>
                <th class="text-left">Admin</th>
                <th class="text-left">{{$t('subscription.userModal.table.status')}}</th>
              
                <th></th>
                <th></th>
                </tr>
            </thead>
            <tbody v-for="user in selectedUserList" :key="user.id">
                    <tr v-if="user.id!=null" >
                        <td></td>
                    <td>{{user.name}}</td>
                    <td>{{user.userName}}</td>
                    <td class="text-center"><i class="text-center" :class="user.isCustomerAdmin  ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'"></i></td>
                    <td><i :class="user.status===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i></td>
                        
                    <td>
                        <b-button @click="changePassword(user)  "   size="sm" variant="outline-dark"  >
                            <i class="fas fa-key font-size-16 align-middle mr-2"></i>{{$t('subscription.userModal.table.chnagePassword')}}
                        </b-button>
                    </td>
                    <td>
                        <a  :title="$t('subscription.userModal.table.edit')" href="javascript:void(0);"  @click="editUser(user)  " class="action-icon text-warning pr-2" >
                            <img alt="Edit" width="20px" src="@/assets/icons/pencil.svg" style="cursor: pointer;" />
                        </a>
                    </td>
                 </tr>

            </tbody>
            </table>
            <span v-if="selectedUserList[0] && selectedUserList[0].id==null" class="d-flex justify-content-center m-4 text-danger" > {{$t('subscription.userModal.table.empty')}} </span>

            </div> 
            
          </div>
        </div>
      </div>
                <b-modal
                        v-if="(showUsersModal && selected)  "
                        v-model="showUsersModal"
                        :title="(isNew ? $t('subscription.userModal.title2') + ' '  + selectedUser.customerName : $t('subscription.userModal.title') + ' ' + selectedUser.name )" 
                        hide-footer 
                        centered 
                        title-class="text-primary"
                        title-tag="h5"
                        header-close-variant="danger"
                        size="lg" 
                        @change="handler(selectedUser.permission)">
                                  <b-button 
                                  v-if="!isNew"
                                    variant="link"
                                    class=" p-0 m-0 pb-3  text-info font-weight-bold font-size-14 float-right" 
                                    @click="addNew()"
                                    >
                                    <i class="fas fa-edit " ></i>
                                    <span class="ml-2 ">{{$t('subscription.userModal.addNew')}} </span>
                                 </b-button>
                                 
                                 <div v-if="showForm" class="conatiner">

                                    <div class="row mt-2 mb-4">
                                        <div class="col-12 ">
                                            <div class="float-left">
                                                <div  class="form-group  ">
                                                    <b-form-checkbox
                                                        value="1"
                                                        unchecked-value="0"
                                                        class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                        v-model="selectedUser.status">   
                                                        <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('subscription.userModal.status.active') : $t('subscription.userModal.status.disabled')}}</span>
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                        </div>  

                                        <div  class="col-12 mt-2 form-group  ">
                                            <b-form-checkbox
                                                :value="true"
                                                :unchecked-value="false"
                                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                v-model="selectedUser.isCustomerAdmin "
                                                >
                                                <span class="font-size-14" :class="selectedUser.isCustomerAdmin == 1  ? 'text-danger' : 'text-muted' ">Administrateur</span>
                                            </b-form-checkbox>
                                        </div>
                                    </div>

                                    <div v-if="showForm" class="row mt-4 pb-2" style="width:100%">
                                        <div class="form-group col-md-12 col-lg-3 pr-4 ">
                                            <label >{{$t('subscription.userModal.form.name')}}</label>
                                            <input
                                            type="text"
                                            class="form-control"
                                            v-model="selectedUser.name"
                                            />
                                    </div>
                                    <div class="form-group col-md-12 col-lg-5 pr-4">
                                        <label >{{$t('subscription.userModal.form.userName')}}</label>
                                        <input
                                        type="text"
                                        class="form-control"
                                        v-model="selectedUser.userName"

                                        />
                                    </div>
                                    <div v-if="isNew" class="form-group col-md-12 col-lg-4 pr-4 ">
                                        <label >{{$t('subscription.userModal.form.password')}}</label>
                                        <form autocomplete="off">
                                                <div class="input-group ">
                                                    <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="selectedUser.password" >
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword()" ></i></span>
                                                    </div>
                                                </div>
                                        </form>
                                    </div>
                        
                                    </div>
                                  
                              
                                <!--   <div  class="conatiner" >

                                             <fieldset class="row   border  p-4 " style="border-width: 2px !important ;" >
                                                <legend class=" font-size-16 text-primary px-2">Liste des Permissions</legend>

                                                <div class="float-left">
                                                            <div  class="col-12 mt-2 form-group  ">
                                                                <b-form-checkbox
                                                                    value="1"
                                                                    unchecked-value="0"
                                                                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                                    v-model="adminPermission.isSelected "
                                                                    >
                                                                    <span class="font-size-14" :class="adminPermission.isSelected == 1  ? 'text-danger' : 'text-muted' ">Administrateur Officine</span>
                                                                </b-form-checkbox>
                                                            </div>
                                                        </div>
                                                        <div class="conatiner mt-4" v-if="adminPermission.isSelected != 1 " >
                                                            <div class="row" >
                                                                <div class="col-lg-6  col-xs-12" v-for="permissionGroup in adminPermissionGroupes" :key="permissionGroup.id">
                                                                    <div class="float-left ">
                                                                            <div class="form-group">
                                                                                <b-form-checkbox
                                                                                    value="1"
                                                                                    unchecked-value="0"
                                                                                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                                                                    v-model="permissionGroup.isSelected"
                                                                                >   
                                                                                    <span class="font-size-14" :class="permissionGroup.isSelected == 1 ? 'text-info' : 'text-muted'" >{{ permissionGroup.label }}</span>
                                                                                    
                                                                                </b-form-checkbox>
                                                                            </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                        
                                            </fieldset>
                                        </div> -->

                                <div v-if="showForm" class="row mt-4" style="width:100%">

                                    <div class="col-lg-6  col-md-5 col-sm-5 " />

                                    <div class="col-lg-3 col-md-3 col-sm-3 pr-3 pb-1 " >
                                            
                                        <b-button variant="secondary" @click="cancelUserEdit();hideForm();" class="mr-2 w-100" >
                                            <i class="fas fa-times font-size-14 align-middle  mr-2" ></i> Annuler
                                        </b-button>
                                    </div>

                                    <div class="col-lg-3 col-md-4 col-sm-4 w-100 pr-sm-0 pr-3 pb-1 " >
                                        <b-button variant="success" @click="saveUser()" class="w-100 font-weight-bold" >
                                            <i class="fas fa-save font-size-14 align-middle mr-2 " ></i> Enregistrer
                                        </b-button>
                                    </div>
                                </div> 
                                
                            </div>
                    
       
          </b-modal>

<!--  change password -->

    <b-modal
                v-if="showPWModal"
                v-model="showPWModal"
                :title="$t('subscription.userModal.title') +selectedUser.name "
                hide-footer 
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                size="lg"
        > 
        <div v-if="isPasswordChange" style="width:100%">
            <div class="form-group row mb-3 pt-2 ">
            <div class="col-md-6 col-form-label" for="pwd">{{$t('subscription.userModal.passwordNew')}} {{selectedUser.name}}</div>
               
            <div class="col-md-4">
                    <form autocomplete="off">
                        <div class="input-group ">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="newPassword" >
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword()" ></i></span>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-md-2" >
                    <b-button variant="secondary" @click="cancelPasswordChangeEdit();hideForm()" class="mr-2 ml-2" >
                        <i class="fas fa-times font-size-14 align-middle  " ></i>
                    </b-button>
                    <b-button variant="success" @click="updatePassword();hideForm()" >
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>
        </div>
         
    </b-modal>
    <!--  change password -->


    </div>


</template>